module.exports = __webpack_public_path__ + "img/magazine rack.68bd0e71.png";